import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { Location } from '@angular/common';
import { NavController } from '@ionic/angular/standalone';

@Injectable({ providedIn: 'root' })
export class NavigationService implements OnDestroy {
  private destroyed$ = new Subject<void>();

  private previousUrl?: string;
  private currentUrl?: string;

  state: { [k: string]: unknown } = {};

  constructor(
    private router: Router,
    private location: Location,
    private navController: NavController,
  ) {
    this.router.events
      .pipe(
        takeUntil(this.destroyed$),
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      )
      .subscribe(event => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
        this.state = {};
      });
  }

  back(): void {
    if (this.previousUrl && this.previousUrl !== '/profile/select') {
      this.location.back();
    } else {
      void this.navController.navigateRoot('home');
    }
  }

  async navigate(url: string, navigationExtra: NavigationExtras = {}): Promise<void> {
    this.state = navigationExtra.state || {};
    await this.router.navigate([url], { ...navigationExtra, state: {} });
  }

  async navigateRoot(url: string, navigationExtra: NavigationExtras = {}): Promise<void> {
    this.state = navigationExtra.state || {};
    await this.navController.navigateRoot(url, { ...navigationExtra, state: {} });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
